<template>
  <div class="fixed bottom-0 flex flex-wrap w-full bg-background text-nav py-5 px-8 button-shadow">
    <div class="flex flex-col gap-2 text-sm md:text-base">
      <p class="">We use cookies to improve your experience on our website. Please choose the types of cookies you would like to allow:</p>
      <div class="flex flex-wrap gap-x-6">
        <div class="my-2">
          <input type="checkbox" id="functional" v-model="necessary" class="mr-2" disabled>
          <label for="functional">Necessary cookies</label>
        </div>
        <div class="my-2">
          <input type="checkbox" id="analytics" v-model="functional" class="mr-2">
          <label for="analytics">Functional cookies</label>
        </div>
        <div class="my-2">
          <input type="checkbox" id="functional" v-model="analytics" class="mr-2">
          <label for="functional">Analytics cookies</label>
        </div>
        <div class="my-2">
          <input type="checkbox" id="analytics" v-model="marketing" class="mr-2">
          <label for="analytics">Marketing cookies</label>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap justify-center gap-2 flex-grow items-center text-sm md:text-base">
      <button class="text-nav underline py-2 px-4 rounded h-fit" @click="denyCookies()">Deny All</button>
      <button class="text-nav underline py-2 px-4 rounded h-fit" @click="acceptCookies()">Save cookie preferences</button>
      <button class="inline-flex items-center justify-center whitespace-nowrap rounded-md px-4 py-2 text-white custom-shadow bg-gradient-to-t from-blue-400 to-nav-btn" @click="acceptAllCookies()">Accept All</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      functional: false,
      analytics: false,
      necessary: true,
      marketing: false
    }
  },
  methods: {
    acceptCookies() {
      const cookiePreferences = {
        functional: this.functional,
        analytics: this.analytics,
        necessary: this.necessary,
        marketing: this.functional
      };
      this.saveCookies(cookiePreferences)
    },
    acceptAllCookies() {
      const cookiePreferences = {
        functional: true,
        analytics: true,
        necessary: true,
        marketing: true
      };
      this.saveCookies(cookiePreferences)
    },
    denyCookies() {
      const cookiePreferences = {
        functional: false,
        analytics: false,
        necessary: true,
        marketing: false
      };
      this.saveCookies(cookiePreferences)
    },
    saveCookies(cookiePreferences) {
      window.dataLayer.push({
        'cookieAnalytics': cookiePreferences.analytics,
      });
      localStorage.setItem('cookiePreferences', JSON.stringify(cookiePreferences));
      this.$emit('cookie-preferences-set');
    }
  }
}
</script>
